<highcharts-chart
  class="chart"
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  [(update)]='updateFlag'
></highcharts-chart>
